import { HiddenReasonType, SitterProfileStatus } from 'us-web-services';

export const isPurchaseBlocked = (status?: SitterProfileStatus | null): boolean =>
  status?.hiddenReason?.id === HiddenReasonType.DECISION;
